import '../modules/listPagination.js';
import '../modules/mapService.js';

import SearchHistoryService from '../../../libs/cmsserver/src/js/services/SearchHistoryService.js';

angular.module( 'artestListPagination' ).service( 'searchHistory', SearchHistoryService );
angular.module( 'dashboardApp.directives', [ 'artestListPagination', 'mapServiceModule' ])
